/**
 * Register global Vue components
 */

import Vue from 'vue'

import LucreLogo from '@/components/global/LucreLogo'
Vue.component('lucre-logo', LucreLogo)

import MainNav from '@/components/global/MainNav'
Vue.component('lucre-main-nav', MainNav)

import SocialLinks from '@/components/global/SocialLinks'
Vue.component('lucre-social-links', SocialLinks)

import FullHeightBlock from '@/components/generic/FullHeightBlock'
Vue.component('lucre-full-height-block', FullHeightBlock)

import SidewaysLabel from '@/components/generic/SidewaysLabel'
Vue.component('lucre-sideways-label', SidewaysLabel)

import MainFooter from '@/components/global/MainFooter'
Vue.component('lucre-main-footer', MainFooter)

import NewsletterSignup from '@/components/generic/NewsletterSignup'
Vue.component('lucre-newsletter-signup', NewsletterSignup)

import NavToggle from '@/components/generic/NavToggle'
Vue.component('lucre-nav-toggle', NavToggle)

import FloatingImage from '@/components/generic/FloatingImage'
Vue.component('lucre-floating-image', FloatingImage)

import ImageGrid from '@/components/generic/ImageGrid'
Vue.component('lucre-image-grid', ImageGrid)

/**
 GAME SECTIONS
 */
import GameHeader from '@/components/game/GameHeader'
Vue.component('lucre-game-header', GameHeader)

import ThreeScreens from '@/components/game/ThreeScreens'
Vue.component('lucre-three-screens', ThreeScreens)

import GameTrailer from '@/components/game/GameTrailer'
Vue.component('lucre-game-trailer', GameTrailer)

import GameLargeImage from '@/components/game/GameLargeImage'
Vue.component('lucre-game-large-image', GameLargeImage)

/**
 * GEOTAP
 */
 import Marquee from '@/components/geotap/Marquee'
 Vue.component('geotap-marquee', Marquee)



// WEBPACK FOOTER //
// ./src/components.js